import mixpanel from 'mixpanel-browser'

export const mixpanelLog = (eventName: string, properties: Record<string, any>) => {
  mixpanel.track(eventName, properties)
}
